<template>
  <v-container>
    <v-row no-gutters justify="space-between" align="center" class="mb-2">
      <v-btn exact text :to="{ name: this.prevRoute }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
      <v-btn text @click="openRecipe" v-if="getIsIntermediate">
        <v-icon small left>fa-external-link-alt</v-icon>
        Ouvrir la fiche technique
      </v-btn>
    </v-row>

    <StatisticsFilter
      class="mb-3"
      @search="search"
      v-bind.sync="filter"
    ></StatisticsFilter>

    <v-row class="mt-3" v-if="filter.productFilter !== undefined" dense>
      <v-col cols="12" sm="4">
        <v-card style="height: 100%;">
          <v-overlay absolute :value="detailLoading">
            <v-row align="center" no-gutters>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-card-text>
            <v-row align="center" justify="space-between" dense no-gutters>
              <span
                class="overline font-weight-medium primary--text"
                style="color: rgba(0, 0, 0, 0.87);"
                >Inventaire actuel</span
              >
              <InventoryDetail
                type="inventory"
                :product="filter.productFilter"
                :loading.sync="detailLoading"
              ></InventoryDetail>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card style="height: 100%;">
          <v-overlay absolute :value="detailLoading2">
            <v-row align="center" no-gutters>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-card-text>
            <v-row align="center" justify="space-between" dense no-gutters>
              <span
                class="overline font-weight-medium primary--text"
                style="color: rgba(0, 0, 0, 0.87);"
                >Dernière saisie</span
              >
              <InventoryDetail
                type="last-entry"
                :product="filter.productFilter"
                :loading.sync="detailLoading2"
              ></InventoryDetail>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card style="height: 100%;">
          <v-overlay absolute :value="detailLoading3">
            <v-row align="center" no-gutters>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-card-text>
            <v-row align="center" justify="space-between" dense no-gutters>
              <span
                class="overline font-weight-medium primary--text"
                style="color: rgba(0, 0, 0, 0.87);"
                >Correction moyenne</span
              >
              <InventoryDetail
                type="correction-value"
                :product="filter.productFilter"
                :loading.sync="detailLoading3"
              ></InventoryDetail>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-2" v-if="filter.productFilter !== undefined">
      <v-col cols="12" sm="6">
        <v-card style="height: 100%;">
          <v-overlay absolute :value="correctionChartLoading">
            <v-row align="center" no-gutters>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-card-title>
            <span class="overline font-weight-medium primary--text"
              >Corrections</span
            >
          </v-card-title>
          <v-card-text>
            <CorrectionBarChart
              v-bind.sync="filter"
              :loading.sync="correctionChartLoading"
            ></CorrectionBarChart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card style="height: 100%;">
          <v-overlay absolute :value="wasteChartLoading">
            <v-row align="center" no-gutters>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
          </v-overlay>
          <v-card-title>
            <span class="overline font-weight-medium primary--text"
              >Pertes</span
            >
          </v-card-title>
          <v-card-text>
            <WasteBarChart
              v-bind.sync="filter"
              :loading.sync="wasteChartLoading"
            ></WasteBarChart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card
      class="mt-2"
      v-if="filter.productFilter !== undefined && $vuetify.breakpoint.smAndUp"
    >
      <v-overlay absolute :value="chartLoading">
        <v-row align="center" no-gutters>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
      </v-overlay>
      <v-card-title>
        <span class="overline font-weight-medium primary--text"
          >Productions & Consommations</span
        >
      </v-card-title>
      <v-card-text>
        <ProductChart
          ref="chart"
          v-bind.sync="filter"
          :loading.sync="chartLoading"
        ></ProductChart>
      </v-card-text>
    </v-card>

    <v-expansion-panels
      v-model="panels"
      multiple
      focusable
      class="mt-2"
      v-if="filter.productFilter !== undefined"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="overline font-weight-medium"
            >Productions & Consommations</span
          ></v-expansion-panel-header
        >
        <v-expansion-panel-content class="dense-table">
          <TransactionsGrid
            ref="transaction"
            v-bind.sync="filter"
          ></TransactionsGrid
        ></v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="overline font-weight-medium"
            >Corrections</span
          ></v-expansion-panel-header
        >
        <v-expansion-panel-content class="dense-table">
          <RecordsCorrectionsGrid
            ref="correction"
            v-bind.sync="filter"
          ></RecordsCorrectionsGrid
        ></v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="overline font-weight-medium"
            >Pertes</span
          ></v-expansion-panel-header
        >
        <v-expansion-panel-content class="dense-table">
          <WastesGrid ref="waste" v-bind.sync="filter"></WastesGrid
        ></v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="overline font-weight-medium">Entrés manuelles</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="dense-table">
          <RecordsGrid ref="record" v-bind.sync="filter"></RecordsGrid
        ></v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="overline font-weight-medium"
            >Utilisations</span
          ></v-expansion-panel-header
        >
        <v-expansion-panel-content class="dense-table">
          <ProductConsumptionGrid
            v-bind.sync="filter"
            dense
          ></ProductConsumptionGrid
        ></v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import moment from "moment";
import {
  RecordsCorrectionsGrid,
  StatisticsFilter,
  WastesGrid,
  TransactionsGrid,
  RecordsGrid,
  ProductChart,
  ProductConsumptionGrid,
  InventoryDetail,
  CorrectionBarChart,
  WasteBarChart
} from "../components";
import { mapGetters } from "vuex";
export default {
  name: "StatisticsDetails",
  components: {
    RecordsCorrectionsGrid,
    StatisticsFilter,
    WastesGrid,
    TransactionsGrid,
    RecordsGrid,
    ProductChart,
    ProductConsumptionGrid,
    InventoryDetail,
    CorrectionBarChart,
    WasteBarChart
  },
  props: {
    id: {
      default: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.prevRoute = from.name;
      await vm.getData();
    });
  },
  async beforeRouteUpdate(to, from, next) {
    await this.getData();
    next();
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes"]),
    getIsIntermediate() {
      if (this.filter.productFilter !== undefined) {
        const p = this.getProducts.find(
          x => x.id === this.filter.productFilter
        );
        if (p) {
          return p.est_intermediaire;
        }
      }
      return false;
    }
  },
  data() {
    return {
      prevRoute: "StatisticsIndex",
      panels: [],
      detailLoading: false,
      detailLoading2: false,
      detailLoading3: false,
      chartLoading: false,
      chartLoading2: false,
      wasteChartLoading: false,
      correctionChartLoading: false,
      filter: {
        period: [
          moment()
            .subtract(30, "d")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD")
        ],
        start: moment()
          .subtract(30, "d")
          .format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        take: null,
        productFilter: undefined,
        groupBy: true
      }
    };
  },
  methods: {
    async getData() {
      this.$store.dispatch("loadRecipes");
      await this.$store.dispatch("loadProducts");
      if (this.id !== null) {
        this.filter.productFilter = Number(this.id);
      }
    },
    search() {
      this.$refs.correction.getData();
      this.$refs.waste.getData();
      this.$refs.transaction.getData();
      this.$refs.record.getData();
      this.$refs.chart.getData();
      this.$refs.chartCorrection.getData();
      this.$refs.invDetail.getData();
    },
    openRecipe() {
      if (this.filter.productFilter !== undefined) {
        const r = this.getRecipes.find(
          x => x.fk_produit_intermediaire === this.filter.productFilter
        );
        if (r) {
          this.$router.push({ name: "RecipeEditor", params: { id: r.id } });
        }
      }
    }
  }
};
</script>

<style></style>
